module.exports = __webpack_public_path__ + "static/media/CT_2019_30451_pdf.c4fc8cde.pdf";